import React, { forwardRef } from "react";

import { palette, space } from "../style/variables";

import { Flex } from "./flex";
import { Text } from "./text";

const getBackgroundColor = (color, disabled, retainColorWhenDisabled) => {
  const backgroundColor = color || "blue";
  if (disabled) {
    return retainColorWhenDisabled ? backgroundColor : "blackTint70";
  }
  return backgroundColor;
};

const RadioButton = forwardRef<any, any>((props, ref) => {
  const {
    autoFocus,
    children,
    disabled,
    name,
    checked,
    onChange,
    option,
    value,
    isDark,
    color,
    retainColorWhenDisabled,
    textSize,
    ...rest
  } = props;
  const isChecked = checked !== undefined ? checked : option === value;
  const textColor = isDark ? "blackTint95" : "blackTint40";
  const textDisabledColor =
    retainColorWhenDisabled && isChecked ? textColor : "blackTint70";

  return (
    <Flex {...rest}>
      <label
        style={{
          alignItems: "center",
          display: "inline-flex",
        }}
        // @ts-ignore: Name isn't valid HTML but all our integration tests rely on this
        name={name}
      >
        <input
          autoFocus={autoFocus}
          checked={isChecked}
          disabled={disabled}
          name={name}
          onChange={handleChange}
          ref={ref}
          type="radio"
          value={option}
          style={{ height: 0, margin: 0, opacity: 0, width: 0 }}
        />
        <Flex
          alignItems="center"
          bgColor={
            isChecked
              ? getBackgroundColor(color, disabled, retainColorWhenDisabled)
              : undefined
          }
          inline
          justifyContent="center"
          none
          style={{
            border: "1px solid",
            borderColor: props.checked ? "transparent" : palette.blackTint70,
            borderRadius: "50%",
            cursor: !props.disabled && "pointer",
            height: space[4],
            width: space[4],
            minWidth: space[4],

            "$label:hover &": {
              backgroundColor:
                !props.disabled && (palette[props.color] || palette.blue),
              borderColor: !props.disabled && "transparent",
            },
          }}
        >
          {isChecked ? (
            <div
              style={{
                backgroundColor: palette.white,
                borderRadius: "50%",
                height: space[2],
                width: space[2],
              }}
            />
          ) : null}
        </Flex>
        <Text
          color={disabled ? textDisabledColor : textColor}
          kind={textSize || "body-s"}
          ml={2}
          style={{ cursor: disabled ? "default" : "pointer" }}
        >
          {children}
        </Text>
      </label>
    </Flex>
  );

  function handleChange(event) {
    onChange(option, event);
  }
});

export { RadioButton };
